<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
  name: "OperateTitle"
});
</script>
<template>
  <div class="o-title">
    <div class="label">{{ props.title }}</div>
    <slot name="right" />
  </div>
</template>

<script setup lang="ts">
;
const props = defineProps({
  title: { type: String, required: true }
});
</script>
<style scoped lang="scss">
.o-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .label {
    font-size: 16px;
    color: #333333;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    margin-left: -20px;
  }
}
</style>
